import React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import logo from "../../images/logo/logo-full-black.png";
import ModalHeader from './../drive/ModalHeader';
import mailUnsubscribeImage from "../../images/grafix-banner/email-unsubscribe.svg";

class UnsubscribeEmail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    async componentDidMount() {
        await dispatch.unsubscribe.unsubscribeEmail({
            accountUserId: this.props.match.params.userId,
            entityName: this.props.match.params.entityName,
            entityId: this.props.match.params.entityId
        });
    }

    render() {
        let unsubscriptionInfo = {}
        if (this.props.emailUnsubscriptionData && this.props.emailUnsubscriptionData.status === 409) {
            unsubscriptionInfo.image = mailUnsubscribeImage
            unsubscriptionInfo.subHeader1 = this.props.emailUnsubscriptionData.message
            unsubscriptionInfo.colorClass = "clr-green"
            unsubscriptionInfo.details = "You have already unsubscribed from the initiative " + this.props.emailUnsubscriptionData.unsubscribedEntityName + "."
        } else if (this.props.emailUnsubscriptionData && this.props.emailUnsubscriptionData.status === 200) {
            unsubscriptionInfo.image = mailUnsubscribeImage
            unsubscriptionInfo.subHeader1 = this.props.emailUnsubscriptionData.message
            unsubscriptionInfo.colorClass = "clr-green"
            unsubscriptionInfo.details = "You have been unsubscribed from the initiative " + this.props.emailUnsubscriptionData.unsubscribedEntityName + "."
        } else if (this.props.emailUnsubscriptionData && this.props.emailUnsubscriptionData.status === 400) {
            unsubscriptionInfo.image = mailUnsubscribeImage
            unsubscriptionInfo.subHeader1 = this.props.emailUnsubscriptionData.message
            unsubscriptionInfo.colorClass = "clr-orange"
            // unsubscriptionInfo.details = "You have been unsubscribed from the initiative " + this.props.emailUnsubscriptionData.unsubscribedEntityName + "."
        }
        else {
            unsubscriptionInfo.image = mailUnsubscribeImage
            unsubscriptionInfo.subHeader1 = this.props.emailUnsubscriptionData.message
            unsubscriptionInfo.colorClass = "clr-orange"
        }

        return (
            <div className="outer">
                <div className="middle bg-banner">
                    {this.props.loading ?
                        <Dimmer inverted active={this.props.loading} page={true}>
                            <Loader size='massive'>Please wait...</Loader>
                        </Dimmer> :
                        <div className="inner">
                            <ModalHeader
                                header={<img src={logo} alt='' />}
                                subHeader={`Hello ${this.props.emailUnsubscriptionData && this.props.emailUnsubscriptionData.unsubscribedUserName}!`} />
                            <div className="ModalContent">
                                <div ><img src={unsubscriptionInfo.image} height="160" /> </div>
                                <div className={` error_text2 ${unsubscriptionInfo.colorClass}`}>{unsubscriptionInfo.subHeader1}</div><br />
                                {
                                    this.props.emailUnsubscriptionData && this.props.emailUnsubscriptionData.status === 409 || this.props.emailUnsubscriptionData.status === 200 || this.props.emailUnsubscriptionData.status === 400 ?
                                        <span className="error_text3">{unsubscriptionInfo.details}</span>
                                        : null
                                }
                                <br />
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        loading: state.loading.effects.unsubscribe.unsubscribeEmail,
        emailUnsubscriptionData: state.unsubscribe.emailUnsubscriptionData,
    };
}

const connectedUnsubscriptionPage = connect(mapStateToProps)(UnsubscribeEmail);

export { connectedUnsubscriptionPage as UnsubscribeEmail };